(function () {
  'use strict';

  function initFAQ(faqSection) {
    var detailsNodes = faqSection.querySelectorAll('.seo-faq__item');

    detailsNodes.forEach(function (details) {
      var summary = details.querySelector('.seo-faq__summary');
      if (!summary) return;

      summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

      details.addEventListener('toggle', function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        if (details.open) {
          detailsNodes.forEach(function (sibling) {
            if (sibling !== details && sibling.open) {
              sibling.open = false;
            }
          });
        }
      });

      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          details.open = !details.open;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var faqSection = document.querySelector('[data-seo-faq]');
    if (faqSection) initFAQ(faqSection);
  });

})();